module.exports = __webpack_public_path__ + "static/media/arduino.e46838f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/arduino.png
// module id = 158
// module chunks = 0